/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CalibrationDataDtoCreatorUser } from './CalibrationDataDtoCreatorUser';
import {
    CalibrationDataDtoCreatorUserFromJSON,
    CalibrationDataDtoCreatorUserFromJSONTyped,
    CalibrationDataDtoCreatorUserToJSON,
} from './CalibrationDataDtoCreatorUser';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { EntityWithCommentType } from './EntityWithCommentType';
import {
    EntityWithCommentTypeFromJSON,
    EntityWithCommentTypeFromJSONTyped,
    EntityWithCommentTypeToJSON,
} from './EntityWithCommentType';
import type { CommentTagType } from './CommentTagType';
import {
    CommentTagTypeFromJSON,
    CommentTagTypeFromJSONTyped,
    CommentTagTypeToJSON,
} from './CommentTagType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface PtwCommentDto
 */
export interface PtwCommentDto {
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PtwCommentDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PtwCommentDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwCommentDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PtwCommentDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    entityId?: string | null;
    /**
     * 
     * @type {EntityWithCommentType}
     * @memberof PtwCommentDto
     */
    entityType?: EntityWithCommentType;
    /**
     * 
     * @type {CalibrationDataDtoCreatorUser}
     * @memberof PtwCommentDto
     */
    creatorUser?: CalibrationDataDtoCreatorUser | null;
    /**
     * 
     * @type {CalibrationDataDtoCreatorUser}
     * @memberof PtwCommentDto
     */
    lastModifierUser?: CalibrationDataDtoCreatorUser | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof PtwCommentDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof PtwCommentDto
     */
    possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {Array<CommentTagType>}
     * @memberof PtwCommentDto
     */
    tags?: Array<CommentTagType> | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    $type?: PtwCommentDtoTypeEnum;
}


/**
 * @export
 */
export const PtwCommentDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoCommentsPtwCommentDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.Comments.PtwCommentDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwCommentDtoTypeEnum = typeof PtwCommentDtoTypeEnum[keyof typeof PtwCommentDtoTypeEnum];



/**
 * Check if a given object implements the PtwCommentDto interface.
 */
export function instanceOfPtwCommentDto(value?: unknown): value is PtwCommentDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwCommentDtoTypeEnum)[0];
}

export function PtwCommentDtoFromJSON(json: any): PtwCommentDto {
    return PtwCommentDtoFromJSONTyped(json, false);
}

export function PtwCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwCommentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'description': json['description'] == null ? undefined : json['description'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'entityType': json['entityType'] == null ? undefined : EntityWithCommentTypeFromJSON(json['entityType']),
        'creatorUser': json['creatorUser'] == null ? undefined : CalibrationDataDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : CalibrationDataDtoCreatorUserFromJSON(json['lastModifierUser']),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(CommentTagTypeFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PtwCommentDtoToJSON(value?: Omit<PtwCommentDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'description': value['description'],
        'entityId': value['entityId'],
        'entityType': EntityWithCommentTypeToJSON(value['entityType']),
        'creatorUser': CalibrationDataDtoCreatorUserToJSON(value['creatorUser']),
        'lastModifierUser': CalibrationDataDtoCreatorUserToJSON(value['lastModifierUser']),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'possibleActions': value['possibleActions'] == null ? undefined : ((value['possibleActions'] as Array<any>).map(PossibleActionDtoToJSON)),
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(CommentTagTypeToJSON)),
        '$type': value['$type'],
    });
}

